<template>
	<v-card class="vcard-container pb-1" elevation="0" color="transparent">
		<v-card
			class="vcard-card"
			elevation="0"
			outlined
			min-width="300"
		>
			<v-card-text class="pa-3">
				<div class="d-flex align-center">
					<v-avatar
						color="teal lighten-1"
						size="48"
						class="mr-3"
					>
						<v-icon color="white" size="28">mdi-account</v-icon>
					</v-avatar>
					<div class="flex-grow-1">
						<div class="font-weight-medium text-body-1">
							{{ contactName }}
						</div>
						<div v-if="phoneNumber" class="text-body-2 text--secondary">
							<v-icon small class="mr-1">mdi-phone</v-icon>
							{{ phoneNumber }}
						</div>
						<div v-if="email" class="text-body-2 text--secondary">
							<v-icon small class="mr-1">mdi-email</v-icon>
							{{ email }}
						</div>
						<div v-if="organization" class="text-body-2 text--secondary">
							<v-icon small class="mr-1">mdi-domain</v-icon>
							{{ organization }}
						</div>
					</div>
				</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions class="pa-2">
				<!-- <v-btn
					small
					text
					color="primary"
					@click="saveToContacts"
				>
					<v-icon small left>mdi-account-plus</v-icon>
					Salva in rubrica
				</v-btn> -->
				<v-spacer></v-spacer>
				<v-btn
					small block
					text
					color="primary"
					@click="downloadVCard"
				>
					<v-icon small left>mdi-download</v-icon>
					Scarica vCard
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-card>
</template>

<script>
	export default {
		name: 'VCardMessage',
		props: {
			message: {
				type: Object,
				required: true
			}
		},

		computed: {
			vcardData() {
				return this.message.vcard_data || {}
			},
			contactName() {
				if (this.vcardData.full_name) {
					return this.vcardData.full_name
				}
				if (this.vcardData.name) {
					const parts = []
					if (this.vcardData.name.first_name) parts.push(this.vcardData.name.first_name)
					if (this.vcardData.name.surname) parts.push(this.vcardData.name.surname)
					return parts.join(' ') || 'Contatto'
				}
				return 'Contatto'
			},
			phoneNumber() {
				if (!this.vcardData.phone) return null
				if (typeof this.vcardData.phone === 'string') {
					return this.vcardData.phone
				}
				if (Array.isArray(this.vcardData.phone) && this.vcardData.phone.length > 0) {
					return this.vcardData.phone[0].number || this.vcardData.phone[0]
				}
				return null
			},
			email() {
				return this.vcardData.email || null
			},
			organization() {
				return this.vcardData.organization || null
			}
		},

		methods: {

			saveToContacts() {
				const queryParams = {}

				if (this.vcardData.name) {
					if (this.vcardData.name.first_name) {
						queryParams.name = this.vcardData.name.first_name
					}
					if (this.vcardData.name.surname) {
						queryParams.surname = this.vcardData.name.surname
					}
				} else if (this.vcardData.full_name) {
					const nameParts = this.vcardData.full_name.split(' ')
					if (nameParts.length > 0) {
						queryParams.name = nameParts[0]
						if (nameParts.length > 1) {
							queryParams.surname = nameParts.slice(1).join(' ')
						}
					}
				}

				if (this.phoneNumber) {
					queryParams.primary_telephone = this.phoneNumber
				}

				if (this.email) {
					queryParams.email = this.email
				}

				if (this.organization) {
					queryParams.business_name = this.organization
				}

				this.$router.push({
					path: '/crm/companies/create',
					query: queryParams
				})
			},

			downloadVCard() {
				if (!this.message.media_urls || this.message.media_urls.length === 0) return

				const baseUrl = this.$store.getters.baseUrl
				const token = localStorage.getItem('user-token')
				let url = this.message.media_urls[0]

				// Build full URL based on media URL type
				if (url.startsWith('/whatsapp/twilio-proxy/')) {
					url = `${baseUrl}/api${url}?token=${token}`
				} else if (url.startsWith('/api/')) {
					url = `${baseUrl}${url}?token=${token}`
				} else if (!url.startsWith('http')) {
					url = `${baseUrl}/api/whatsapp/media/${this.message.id}/0?token=${token}`
				}

				const link = document.createElement('a')
				link.href = url
				link.download = `${this.contactName.replace(/[^a-z0-9]/gi, '_')}.vcf`
				link.target = '_blank'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		}
	}
</script>

<style scoped>
	.vcard-container {
		max-width: 350px
	}

	.vcard-card {
		border-radius: 8px;
		border: 1px solid #e0e0e0
	}
</style>
